<div class="create-oeq-view">
    <div class="heading">
        <div>{{data.update ? 'Update' : 'Add New'}} Open Ended Question</div>
        <mat-icon aria-hidden="false" aria-label="close icon" class="close-icon" (click)="cancel()">close</mat-icon>
    </div>
    <form [formGroup]="createOeqFrom" mat-dialog-content>
        <div class="time-limit-level-section">
            <div class="d-level">
                <label class="label-txt">DIFFICULTY LEVEL</label>
                <mat-form-field appearance="outline" class="level-form-field">
                    <mat-label>Levels</mat-label>
                    <mat-select formControlName="difficultyLevel">
                        <mat-option *ngFor="let level of difficultyLevels" [value]="level.id">{{level.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="editor-section">
            <label class="label-txt">QUESTION</label>
            <angular-editor formControlName="questionText" [config]="oeEditorConfig"
                id="openEndedConfig"></angular-editor>
        </div>

        <!-- Optional manual answer (collapsed by default) -->
        <mat-accordion class="manual-answer-accordion">
            <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Manual Answer (optional)
                    </mat-panel-title>
                    <mat-panel-description>
                        Add an example answer for reviewers/candidates
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <div class="editor-section">
                    <angular-editor formControlName="answer" [config]="oeEditorConfig"></angular-editor>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <div class="topics-tags-sec">
            <div class="topic-form-field">
                <label class="label-txt">TOPICS</label>
                <div class="topics">
                    <ng-container infiniteScroll [infiniteScrollDistance]="2"
                        [infiniteScrollContainer]="'.topics .item2'" [infiniteScrollThrottle]="50" [fromRoot]="true"
                        (scrolled)="getNextBatchTopics()">
                        <div class="dropdown-chip-container">
                            <ng-multiselect-dropdown appFocusOnClick [placeholder]="'Select a topic...'"
                                [settings]="topicsSettings" [data]="topics" formControlName="selectedTopics"
                                (onSelect)="onTopicItemSelect($event)" (onDeSelect)="onTopicDeselect($event)"
                                (onFilterChange)="onTopicFilterChange($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="topic-form-field">
                <label class="label-txt">Choose Sub Topics (Optional)</label>
                <div class="sub-topics">
                    <ng-container infiniteScroll [infiniteScrollDistance]="2"
                        [infiniteScrollContainer]="'.sub-topics .item2'" [infiniteScrollThrottle]="50" [fromRoot]="true"
                        (scrolled)="getNextBatchSubTopics()">
                        <div class="dropdown-chip-container">
                            <ng-multiselect-dropdown appFocusOnClick [placeholder]="'Search a topic...'"
                                [settings]="subTopicsSettings" [data]="subTopics" formControlName="subTopics"
                                [disabled]="!hasSelectedTopics()" (onFilterChange)="onFilterChange($event)">
                            </ng-multiselect-dropdown>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </form>
    <div class="actions">
        <button mat-flat-button [disabled]="!createOeqFrom.valid" color="primary" (click)="addOrUpdateQuestion()">
            {{data.update ? 'Update Question' : 'Add Question'}}
        </button>
    </div>
</div>